import { getEl } from '../helpers/helpers.js'
import { createFormState, registerFormSubmit } from '../helpers/waitingList.js'

export function initWaitingList() {
	const form = getEl('.waiting-list')
	if (!form) return false

	const formState = createFormState(form)
	registerFormSubmit(formState)
	return true
}
